<script context="module">
  import { writable } from 'svelte/store';
  import { sgettext } from '../../i18n.js';
  import { getSetting } from '../../utils.js';

  const checked = writable(getSetting('showSubBranches') === "true" ? true : false);
  export { checked };

  export function labelWithCount(label, count) {
	const countLabel = count != null ? ` (${count})` : '';
    return `${sgettext(label)}${countLabel}`;
  };
</script>

<script>

import HomePageAllTab from "./HomePageAllTab.svelte";
import HomePageTimeConfirmationTab from './HomePageTimeConfirmationTab.svelte';

import RoutedTabs from '../RoutedTabs/RoutedTabs.svelte';
import RoutedTab from '../RoutedTabs/RoutedTab.svelte';
import RoutedTabPanel from '../RoutedTabs/RoutedTabPanel.svelte';
import RoutedTabBar from '../RoutedTabs/RoutedTabBar.svelte';

import {setSetting} from '../../utils.js';

import {allActivities, draftActivities, invalidActivities, pendingActivities, supersededActivities,
  allElements, draftElements, invalidElements,
  allInstances, inProgressInstances, archivedInstances, executedInstances, scheduledInstances} from './dashBoardStrore.js';
  import HomePageSchedule from './HomePageSchedule.svelte';
  import OpenImprovements from './OpenImprovements.svelte';
  import HomePageActivities from './HomePageActivities.svelte';
  import HomePageElements from './HomePageElements.svelte';

export let branch = 'BHP';
export let branchId = 1;

export let workOrderAutomationEnabled = false;
export let D2Enabled = false;

async function changeCheckboxValue(event){
  await clearStoreValues();
  setSetting("showSubBranches", event.currentTarget.checked);
}

async function clearStoreValues(){
  //clear activities section
  allActivities.set({});
  draftActivities.set({});
  invalidActivities.set({});
  pendingActivities.set({});
  supersededActivities.set({});

  //clear elements section
  allElements.set({});
  draftElements.set({});
  invalidElements.set({});

  //clear schedule section
  allInstances.set({});
  inProgressInstances.set({});
  archivedInstances.set({});
  executedInstances.set({});
  scheduledInstances.set({});
}
</script>

<div class="homepage">
	<h1 class="text-primary mb-4">
		{sgettext("$$SEE_HAPPENING$$")}
		{@html branch}
	</h1>
	<RoutedTabs persistKey="homepage">
		<RoutedTabBar>
			<RoutedTab
				path="/"
				label={sgettext('$$ALL$$')}
				component={HomePageAllTab}
				{branchId}
				{branch}
                {workOrderAutomationEnabled}
			/>
            <RoutedTab
                path="/time-confirmations"
                label={sgettext('$$TIME_CONFIRMATIONS$$')}
                component={HomePageTimeConfirmationTab}
                {branchId}
                {branch}
            />
            <RoutedTab
				path="/schedule"
				label={sgettext('$$SCHEDULE$$')}
				component={HomePageSchedule}
                execution={true}
				{branchId}
                {workOrderAutomationEnabled}
			/>
            <RoutedTab
                path="/improvements"
                label={sgettext('$$IMPROVEMENTS$$')}
                component={OpenImprovements}
                {branchId}
                {branch}
            />
            <RoutedTab
                path="/activities"
                label={sgettext('$$ACTIVITIES$$')}
                component={HomePageActivities}
                {branchId}
                {branch}
            />
            <RoutedTab
                path="/elements"
                label={sgettext('$$ELEMENTS$$')}
                component={HomePageElements}
                {branchId}
                {branch}
            />
		</RoutedTabBar>

		<RoutedTabPanel>
			<div style="display: flex; flex-direction: row-reverse">
				<label>
					<input
						type="checkbox"
						bind:checked={$checked}
						on:change={event => changeCheckboxValue(event)}
					/>
					{sgettext('$$SHOW_CONTENT_SUBBRANCHES$$')}
				</label>
			</div>
			<hr style="margin-top: 0" />
		</RoutedTabPanel>
	</RoutedTabs>
</div>

<style>
	.homepage :global(tbody tr:hover) {
		cursor: pointer;
	}
	.homepage :global(table) {
		/* this is here to prevent a double border due to a table in a .card */
		border: 0 !important;
	}

	.homepage :global(.subtabs label) {
		font-size: 20px;
		margin-top: 5px;
	}

	.homepage :global(.subtabs .nav-pills .nav-item button.nav-link) {
		background-color: #f2f4f5;
		color: #212529;
		font-weight: initial;
		line-height: initial;
		padding: 5px 15px;
	}

	.homepage :global(.subtabs .nav-pills .nav-item button.nav-link.active) {
		color: #212529;
		background-color: #dee2e6;
		border: 1px solid gray;
		border-radius: 5px;
		/* slightly smaller padding to cope with border */
		padding: 4px 14px;
	}

	.homepage :global(.subtabs) {
		margin-bottom: 30px;
	}

	.homepage :global(.table-sm th) {
  		padding-left: 15px;
    }

	.homepage :global(.table-sm td) {
  		padding-left: 15px;
    }
</style>
